<template>
  <div>
    <div class="d-flex">
      <j-import-file
        v-if="default_import"
        :href-sample="require('@/assets/file/FORMAT_RULE_IMPORT.zip')"
        @import-data="importData"/>
      <b-button
        v-if="is_error"
        class="btn outline red"
        @click="$refs.modalFlow.show()">
        <i class="fa fa-close"/>
        OPEN ERROR DATA
      </b-button>
      <b-button
        v-else-if="data_import"
        class="btn green"
        @click="uploadData">
        UPLOAD
      </b-button>
    </div>

    <div>
      <b-modal
        ref="modalFlow"
        class="mod-form"
        centered>
        <h3 class="float-to-center c--red">
          Error Data
        </h3>
        <v-client-table
          v-if="error_data[0]"
          :data="error_data"
          :columns="column"
          :options="option"
          class="jTable">

          <div
            slot="ERROR"
            slot-scope="props">
            <div
              v-for="(err, index) in props.row.ERROR"
              :key="index">
              {{ err }}
            </div>
          </div>

        </v-client-table>
        <download-excel
          :data="error_data"
          class="float-to-right m__t--30"
          name="rule-data-error.xls">
          <b-button class="btn green">
            Export Error
          </b-button>
        </download-excel>
      </b-modal>
    </div>

    <jProgressScreen
      ref="ImportFile"
      :data-kirim="data_import"
      :url-api="url"
      :headers="headers"
      @finish="uploadDone"/>

  </div>

</template>

<script>
import Vue from 'vue';
import jProgressScreen from '@/components/progress-screen/jProgressScreen';

export default {
  components: {
    jProgressScreen,
  },
  data() {
    return {
      rowing: null,
      default_import: true,
      data_import: null,
      is_finish: false,
      list_error: [],
      error_data: [],
      is_error: false,
      column: ['RULE_ID', 'NAME', 'SET_OF_FLOW', 'ERROR'],
      option: {
        filterable: false,
        perPage: 5,
        perPageValues: [5, 10, 20, 50, 100],
      },
    };
  },
  computed: {
    headers() {
      const token = Vue.ls.get('Token');
      const headers = {
        baseURL: process.env.GATE_URL,
        Authorization: `Bearer ${token}`,
      };
      return headers;
    },

    url() {
      const getEnv = [`${process.env.GATE_URL}jojoflow/rule/import/single`];
      return getEnv;
    },
  },
  watch: {

  },
  methods: {
    importData(val) {
      const fileData = val;
      const genNewData = [];
      const keys = Object.keys(val[0]);
      if (keys[0] !== 'RULE_ID') {
        keys.unshift('RULE_ID');
      }
      if (keys[1] !== 'NAME' || keys[2] !== 'SET_OF_FLOW') {
        this.$store.commit('jStoreNotificationScreen/getProblemMessage', 'Please use header format correctly');
        this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Please use header format correctly');
      }
      this.is_error = false;
      this.list_error = [];
      this.error_data = val;
      fileData.forEach((data, index) => {
        // eslint-disable-next-line
        data.NAME = data.NAME ? data.NAME : '';
        // eslint-disable-next-line
        data.RULE_ID = data.RULE_ID ? data.RULE_ID : '';
        // eslint-disable-next-line
        data.SET_OF_FLOW = data.SET_OF_FLOW ? data.SET_OF_FLOW : '';

        const pack = this.convertData(data, index);
        if (pack.id === 0) {
          genNewData.push(pack);
        } else {
          const filterData = genNewData.filter(fil => fil.id === pack.id);
          const addMoreFlow = filterData.length > 0;

          if (addMoreFlow) {
            filterData[0].flows.push(...pack.flows);
            filterData[0].index.push(...pack.index);
            filterData[0].flows.forEach((sorting, i) => {
              const paramSort = sorting;
              paramSort.order = Number(i + 1);
            });
          } else {
            genNewData.push(pack);
          }
        }
      });
      this.data_import = genNewData;
      const changeId = this.data_import.map((id) => {
        const storeId = id;
        if (typeof storeId.id === 'string') {
          storeId.id = 0;
          return storeId;
        }
        return storeId;
      });
      this.data_import = changeId;
      const errorData = this.error_data.map(data => (
        {
          RULE_ID: data.RULE_ID,
          NAME: data.NAME,
          SET_OF_FLOW: data.SET_OF_FLOW,
          ERROR: data.ERROR,
        }
      ));
      this.error_data = errorData;
      // this.$refs.ImportFile.toggleIsVisible();
    },
    convertData(passingData, indexData) {
      this.list_error[indexData] = [];
      this.$set(this.error_data[indexData], 'ERROR', []);

      // packing
      const packing = {
        id: 0,
        name: '',
        description: '',
        flows: [],
        index: [indexData + 1],
      };

      // validation rule id
      const ruleId = passingData.RULE_ID ? passingData.RULE_ID.trim() : '';
      const isEmpty = ruleId.length === 0 ? 0 : ruleId;
      const isNumber = isNaN(Number(isEmpty)) ? isEmpty : Number(isEmpty);
      packing.id = isNumber;

      // validation NAME
      const ruleName = passingData.NAME ? passingData.NAME.trim() : '';
      if (ruleName.length === 0) {
        this.is_error = true;
        this.list_error[indexData].push('- field name is required');
        this.error_data[indexData].ERROR.push('- field name is required');
      } else {
        packing.name = ruleName;
      }

      // validation set of Flow
      const setFlows = passingData.SET_OF_FLOW ?
        passingData.SET_OF_FLOW.trim() : '';

      if (setFlows.length === 0) {
        this.is_error = true;
        this.list_error[indexData].push('- field set of flow is required');
        this.error_data[indexData].ERROR.push('- field set of flow is required');
      } else {
        let splitSemicolon;
        if (setFlows.indexOf(',') > -1) {
          splitSemicolon = setFlows.split(',');
        } else {
          splitSemicolon = [setFlows];
        }

        // const ruleData = splitSemicolon.map(data => Number(data));
        const ruleData = splitSemicolon.map((data, index) => ({
          id: Number(data),
          order: Number(index + 1),
        }));

        packing.flows = [...ruleData];
      }

      return packing;
    },
    uploadData() {
      this.$refs.ImportFile.toggleIsVisible();
    },
    uploadDone() {
      this.$emit('upload-done');
      this.data_import = null;
      this.default_import = false;
      setTimeout(() => {
        this.default_import = true;
      }, 100);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/flow-rule/rules/jImportRules.vue